import { savedCompetitionSelection } from '../../../../../services/hooks/Registration/registrationCompetition';
import {
  Accordion,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Td,
  Text,
  Textarea,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import MainCard from '../../../../../components/MainCard/Index';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { ContextAuth } from '../../../../../contexts/Authentication';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import AccordionTemplate from '../../../../../components/AccordionTemplate/Index';
import { useRequestGetDataToRegistration } from '../../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import { FieldErrors, FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  FileCollection,
  validadeFileName,
  validateMaxFile,
  validateTypeFile,
  validationSizeFile,
} from '../../../../../utils/validationForm';
import MessageError from '../../../../../components/MessageError';
import { useCreateRegistration } from '../../../../../services/hooks/Registration/usePostRegistration';
import VacancyCutureHome from '../../../../../components/pages/Registration/CultureHousesVacancy';
import DefaultVacancyForm, { ETypeOfCompetition } from '../../../../../components/pages/Registration/DefaultVacancy';
import { TextL, TextXS, TextXXS } from '../../../../../components/Text/Index';
import { useRequestSelectiveProcessVacancy } from '../../../../../services/hooks/SelectiveProcess/useRequestSelectiveProcessVacancy';
import { useRequestGetExemptionType } from '../../../../../services/hooks/Exemptions/useRequestGetExemptionType';
import MarrowDonnor from '../../../Exemptions/Forms/MarrowDonnor/Index';
import NIS from '../../../Exemptions/Forms/NIS/Index';
import { useGetRegistration } from '../../../../../services/hooks/Registration/useGetRegistration';
import TableCustom from '../../../../../components/pages/CandidateArea/Table';
import { handleDeleteAttach } from '../../../../../utils/functions';
import MessageForUser from '../../../../../components/pages/SelectiveProcess/MessageForUser';
import { IoTrash } from 'react-icons/io5';
import CreateRegistrationMobilePage, { ERegistrationType } from '../../../Registration/Mobile';
import { UseRegistration } from '../../../../../Store/useRegistration';
import { IResponseIdName } from '../../../../../services/hooks/globalQuery';
import { useRequestDetailSelectiveProcess } from '../../../../../services/hooks/SelectiveProcess/useRequestDetailSelectiveProcess';
import EconomicHyposufficiency from '../EconomicHyposufficiency';
import ExistingExemptionAttachments from '../ExistingExemptionAttachments';
import {
  getExemptionAttachmentError,
  getExemptionType,
  isBoneMarrowExemption,
  isCadunicoExemption,
  isEconomicExemption,
} from '../../../../../services/hooks/Exemptions/economicHyposufficiency';

const SubscriptonAndExemption: React.FC = () => {
  const { onResetRegistration, setRegistrationId, setSelectiveProcessId } = UseRegistration();
  const navigate = useNavigate();
  const { signOut, candidate, isMobile } = useContext(ContextAuth);
  const modal = useDisclosure();
  const [attachToDeletId, setAttachToDeleteId] = useState<string>('');
  const toast = useToast();

  const url = useLocation().pathname.split('/')[2];

  const { registrationId: editRegistrationId, id: exemptionRegistrationId } = useParams();
  const registrationId = editRegistrationId || exemptionRegistrationId || '';
  const registration = useGetRegistration(registrationId);

  const attachSpecialCondition = ['Arquivo', 'Data de envio', 'Ações'];

  const isValidUUID = (uuid: string) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
  };

  const selectiveProcessId = isValidUUID(url) ? url : '';

  const spDetail = useRequestDetailSelectiveProcess(selectiveProcessId);

  const getExemption = useRequestGetExemptionType(selectiveProcessId);

  const selectiveProcessData = useRequestGetDataToRegistration(selectiveProcessId);
  const selectiveProcessVacancy = useRequestSelectiveProcessVacancy(
    selectiveProcessId,
    selectiveProcessData.data?.is_cultural_house || false,
  );

  const { mutateAsync, isPending } = useCreateRegistration();

  const schema = Yup.object().shape({
    nis: Yup.string()
      .test('isRequired', 'NIS é obrigatório', (value, context) => {
        const type = getExemptionType(context.parent.type_exemption, getExemption.data);
        return !isCadunicoExemption(type?.name) || !selectiveProcessData.data?.request_nis || Boolean(value?.trim());
      })
      .test('minLength', 'O campo deve ter 11 dígitos', (value, ctx) => {
        const type = getExemptionType(ctx.parent.type_exemption, getExemption.data);
        return !isCadunicoExemption(type?.name) || !selectiveProcessData.data?.request_nis || /^\d{11}$/.test(value || '');
      }),
    redome_code: Yup.string().test('isRequired', 'Campo é obrigatório', (value, context) => {
      const type = getExemptionType(context.parent.type_exemption, getExemption.data);
      return !isBoneMarrowExemption(type?.name) || !selectiveProcessData.data?.request_redome || Boolean(value?.trim());
    }),
    terms: Yup.boolean().test('isRequired', 'É necessario aceitar os termos para continuar', (accept) => {
      if (selectiveProcessData.data?.display_terms_acceptance_before_registration) {
        if (!accept) {
          toast({
            title: 'Atenção',
            description: 'É necessario aceitar os termos para continuar',
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
          navigate(`/processo-seletivo/informacoes/${selectiveProcessId}`);
          return accept;
        }
      }

      return accept;
    }),
    eligibility_declaration: Yup.boolean().test('isRequired', 'É necessario aceitar para continuar', function (accept) {
      if (selectiveProcessData?.data?.show_eligibility_declaration) {
        if (!accept) return false;
      }
      return true;
    }),
    is_declaration_veracity: Yup.boolean().test(
      'isRequired',
      'Para continuar, é necessario aceitar o termo de veracidade das informações!',
      (accept) => {
        return accept;
      },
    ),
    type_of_competition: Yup.string().when({
      is: () => !selectiveProcessData.data?.is_cultural_house,
      then: (schema) => schema.required('Campo Obrigatório'),
    }),
    vacancy: Yup.string().when({
      is: () => !selectiveProcessData.data?.is_cultural_house || selectiveProcessData.data?.is_cultural_house,
      then: (schema) => schema.required('Campo Obrigatório'),
    }),
    culture_home: Yup.string()
      .transform((value) => value ?? '')
      .when({
        is: () => selectiveProcessData.data?.is_cultural_house,
        then: (schema) => schema.required('Campo Obrigatório'),
      }),
    // vagancy_type: Yup.string().when(['culture_home'], {
    //   is: (culture_home: string) => !!culture_home,
    //   then: (schema) => schema.required('O Campo é obrigatorio'),
    // }),
    // initial_semester: Yup.string().when(['vagancy_type'], {
    //   is: (vagancy_type: string) => vagancy_type === 'is_initial_semester',
    //   then: (schema) => schema.required('O Campo é obrigatorio'),
    // }),
    // nivel_test: Yup.string().when(['vagancy_type'], {
    //   is: (vagancy_type: string) => vagancy_type === 'is_level_test',
    //   then: (schema) => schema.required('O Campo é obrigatorio'),
    // }),
    culture_home_secondary: Yup.string()
      .transform((value) => value ?? '')
      .when(['has_second_vacancy'], {
        is: (hasSecondVacancy: boolean) => Boolean(selectiveProcessData.data?.is_cultural_house && hasSecondVacancy),
        then: (schema) => schema.required('O Campo é obrigatorio'),
      }),
    type_of_competition_id: Yup.string(),
    allow_filter_vacancy_tree: Yup.string(),
    research_line: Yup.string(),
    thematic_axis: Yup.string(),
    initial_semester_secondary: Yup.string()
      .transform((value) => value ?? '')
      .when(['has_second_vacancy'], {
        is: (hasSecondVacancy: boolean) => Boolean(selectiveProcessData.data?.is_cultural_house && hasSecondVacancy),
        then: (schema) =>
          schema
            .required('O Campo é obrigatorio')
            .test('Campos iguais', 'Atenção! A sua segunda opção de turma deve ser diferente da primeira.', () => {
              if (hookForms.watch('vacancy') === hookForms.watch('initial_semester_secondary')) {
                toast({
                  title: 'Atenção',
                  description: 'Atenção! A sua segunda opção de turma deve ser diferente da primeira.',
                  status: 'warning',
                  duration: 4000,
                  isClosable: true,
                });
                return false;
              }
              return true;
            }),
      }),
    juror_art_440_cpp: Yup.string().test('isRequired', 'O campo é obrigatorio', (value) => {
      if (selectiveProcessData.data?.juror_under_article_440 && value?.length == 0) return false;
      return true;
    }),
    weapon_carry_permit: Yup.boolean(),
    medical_report: Yup.mixed()
      .test('isRequired', 'Envie o seu laudo para prosseguir na vaga destinada a PCD.', function (file) {
        const { modality_type, type_of_competition } = this.parent;
        const isPCD = verifyIsPcd(modality_type, type_of_competition);

        if (!isPCD) return true;

        const listFile = file as FileList;
        const hasExistingReport = Boolean(
          registrationId &&
            registration.data?.reserved_vacancy?.some(
              (reserved) => reserved.type.toLowerCase().includes('pcd') && reserved.attachments?.length > 0,
            ),
        );
        return (listFile?.length ?? 0) > 0 || hasExistingReport;
      })
      .test('validationSizeFile', 'Tamanho máximo para arquivos é de 2MB', function (file) {
        const { modality_type, type_of_competition } = this.parent;
        const isPCD = verifyIsPcd(modality_type, type_of_competition);

        if (!isPCD) return true;

        const listFile = file as FileList;
        if (!listFile?.length) return true;

        return validationSizeFile(listFile);
      })
      .test('validationMaxFile', 'Quantidade máxima de arquivos é de 5 arquivos', function (file) {
        const { modality_type, type_of_competition } = this.parent;
        const isPCD = verifyIsPcd(modality_type, type_of_competition);

        if (!isPCD) return true;

        const listFile = file as FileList;
        if (!listFile?.length) return true;

        return validateMaxFile(listFile);
      })
      .test('validationTypeFile', 'Formato de arquivo não suportado', function (file) {
        const { modality_type, type_of_competition } = this.parent;
        const isPCD = verifyIsPcd(modality_type, type_of_competition);

        if (!isPCD) return true;

        const listFile = file as FileList;
        if (!listFile?.length) return true;

        return validateTypeFile(listFile);
      }),
    cid: Yup.string().when(['modality_type', 'type_of_competition', 'vacancy'], {
      is: (modality: string[] = [], type: string = '') => verifyIsPcd(modality, type),
      then: (schema) => schema.required('Campo é obrigatório').max(100, 'Máximo de 100 caracteres'),
      otherwise: (schema) => schema.notRequired(),
    }),
    deficiency: Yup.string().when(['modality_type', 'type_of_competition', 'vacancy'], {
      is: (modality: string[] = [], type: string = '') => verifyIsPcd(modality, type),
      then: (schema) => schema.required('Campo é obrigatório').max(5000, 'Máximo de 5000 caracteres'),
      otherwise: (schema) => schema.notRequired(),
    }),
    has_special_condition: Yup.string().when({
      is: () => selectiveProcessData.data?.allows_special_condition,
      then: (schema) => schema.required('O campo é obrigatorio'),
    }),
    modality_type: Yup.array().test('isRequired', 'Selecione ao menos uma modalidade!', function (listModality) {
      if (selectiveProcessData.data?.is_cultural_house) return true;

      if (
        !selectVacancy?.type_of_competition ||
        hookForms.getValues('type_of_competition') !== ETypeOfCompetition.SPECIAL_VACANCY ||
        (selectVacancy?.type_of_competition && selectVacancy?.type_of_competition.length === 0)
      )
        return true;

      let isEmpty = false;

      listModality?.forEach((modality) => {
        if (modality !== false) isEmpty = true;
      });

      return isEmpty;
    }),
    sub_type_of_competition: Yup.array()
      .nullable()
      .test(
        'singleOption',
        'Selecione apenas uma opção!',
        (value) => !selectiveProcessData.data?.allow_filter_vacancy_tree || (value ?? []).filter(Boolean).length <= 1,
      )
      .test('isRequired', 'Selecione o grupo a que pertence!', function (value) {
        const { modality_type, vacancy } = this.parent;
        if (this.parent.type_of_competition !== ETypeOfCompetition.SPECIAL_VACANCY) return true;

        const vacancyModality =
          selectiveProcessVacancy.data?.find((vac: IResponseIdName) => vac.id === vacancy)?.type_of_competition ?? [];

        const searchModality = vacancyModality?.find((modality: IResponseIdName) =>
          modality.name.toLowerCase().includes('pppiq'),
        );

        let isEmpty = true;

        if (
          searchModality &&
          modality_type &&
          modality_type.length > 0 &&
          (value?.every((v) => v === false) || !value)
        ) {
          modality_type
            .filter((item: string) => item)
            .forEach((item: string) => {
              try {
                const json = JSON.parse(item);
                if (json.id === searchModality.id) isEmpty = false;
              } catch (error) {
                if (item === searchModality.id) isEmpty = false;
              }
            });
        }

        return isEmpty;
      }),
    has_second_vacancy: Yup.boolean(),
    attachmentFile: Yup.array(),
    protocol_attachmentFile: Yup.array(),
    protocol_photo: Yup.array(),
    observation: Yup.array(),
    selectedSpecialCondition: Yup.array()
      .test('isRequired', 'Selecione ao menos um atendimento especial', (specialConditionList) => {
        let isEmpty = false;

        if (!(hookForms.getValues('has_special_condition') === 'yes')) return true;

        specialConditionList?.forEach((modality) => {
          if (modality !== false) {
            isEmpty = true;
            return;
          }
        });

        return isEmpty;
      })
      .test('isRequired', '', (specialConditionList) => {
        if (!(hookForms.getValues('has_special_condition') === 'yes')) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modality, index) => {
          if (modality !== false) {
            const observation: string = hookForms.getValues(`observation.${index}`);
            if (observation?.length === 0) {
              if (!selectiveProcessData.data?.special_condition[index].is_social_name) {
                validationError.push(
                  new Yup.ValidationError('Campo Obrigatorio', specialConditionList[index], `observation.${index}`),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }

        return true;
      })
      .test('isRequired', 'Campo obrigatório', (specialConditionList) => {
        if (registrationId) {
          const validationError: Yup.ValidationError[] = [];

          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );

            if (modality !== false) {
              const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
              const spc = registration.data?.special_conditions.find((sp) => sp?.id === modality);
              if (spc?.attachments && spc?.attachments?.length > 0) {
                if (file?.length === 0 && registration.data?.special_conditions[index]?.attachments?.length === 0) {
                  if (specialConditionDataToRegistration?.has_attachment) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Selecione um arquivo para continuar',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  } else {
                    return true;
                  }
                }

                return true;
              } else if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList.filter((sp) => sp !== false)[index],
                    `attachmentFile.${index}`,
                  ),
                );
                return;
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }

        if (!registrationId) {
          const validationError: Yup.ValidationError[] = [];
          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
              if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }
      })
      .test('TypeFile', 'Tipo de arquivo nao suportado', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validateTypeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tipo de arquivo nao suportado',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFileSize', '', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validationSizeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tamanho máximo para arquivos é de 2MB',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFile', 'Quantidade maxima de arquivos atingida (5)', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`attachmentFile.${index}`);
            if (attach && attach?.length > 0) {
              registration.data?.special_conditions.forEach((value) => {
                if (value.id === modalityListFile) {
                  const file = value?.attachments?.length || 0;
                  if (file > 4) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Quantidade maxima de arquivos atingida (5)',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  }
                }
              });
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('FileName', 'Nome de arquivo invalido', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`attachmentFile.${index}`);
            if (attach?.length > 0) {
              const file = validadeFileName(attach);

              if (!file) {
                validationError.push(
                  new Yup.ValidationError(
                    'Nome do arquivo invalido',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      }),
    social_name_protocol: Yup.array(),
    has_protocol: Yup.string(),
    selectedProtocol: Yup.array()
      .test('isRequired', '', (protocolList) => {
        // if (!(hookForms.getValues('has_protocol') === 'yes')) return true;

        const validationError: Yup.ValidationError[] = [];

        protocolList?.forEach((modality, index) => {
          if (modality !== false) {
            const social_name: string = hookForms.getValues(`social_name_protocol.${index}`);
            if (social_name?.length === 0) {
              validationError.push(
                new Yup.ValidationError('Campo Obrigatorio', protocolList[index], `social_name_protocol.${index}`),
              );
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }

        return true;
      })
      .test('isRequired', 'Campo obrigatório', (protocolList) => {
        if (registrationId) {
          const validationError: Yup.ValidationError[] = [];

          protocolList?.forEach((modality, index) => {
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`protocol_attachmentFile.${index}`);
              const spc = registration.data?.protocol.find((sp) => sp?.protocol_type.id === modality);
              if (spc?.attachments && spc?.attachments?.length > 0) {
                if (file?.length === 0 && registration.data?.protocol[index]?.attachments?.length === 0) {
                  validationError.push(
                    new Yup.ValidationError(
                      'Selecione um arquivo para continuar',
                      protocolList[index],
                      `protocol_attachmentFile.${index}`,
                    ),
                  );
                }

                return true;
              } else if (file?.length === 0) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    protocolList.filter((sp) => sp !== false)[index],
                    `protocol_attachmentFile.${index}`,
                  ),
                );
                return;
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }

        if (!registrationId) {
          const validationError: Yup.ValidationError[] = [];
          protocolList?.forEach((modality, index) => {
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`protocol_attachmentFile.${index}`);
              if (file?.length === 0) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    protocolList[index],
                    `protocol_attachmentFile.${index}`,
                  ),
                );
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }
      })
      .test('TypeFile', 'Tipo de arquivo nao suportado', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`protocol_attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validateTypeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tipo de arquivo nao suportado',
                    protocolList[index],
                    `protocol_attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFileSize', '', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`protocol_attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validationSizeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tamanho máximo para arquivos é de 2MB',
                    protocolList[index],
                    `protocol_attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFile', 'Quantidade maxima de arquivos atingida (5)', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`protocol_attachmentFile.${index}`);
            if (attach && attach?.length > 0) {
              registration.data?.special_conditions.forEach((value) => {
                if (value.id === modalityListFile) {
                  const file = value?.attachments?.length || 0;
                  if (file > 4) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Quantidade maxima de arquivos atingida (5)',
                        protocolList[index],
                        `protocol_attachmentFile.${index}`,
                      ),
                    );
                  }
                }
              });
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('FileName', 'Nome de arquivo invalido', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`protocol_attachmentFile.${index}`);
            if (attach?.length > 0) {
              const file = validadeFileName(attach);

              if (!file) {
                validationError.push(
                  new Yup.ValidationError(
                    'Nome do arquivo invalido',
                    protocolList[index],
                    `protocol_attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('isRequired', 'Campo obrigatório', (protocolList) => {
        if (registrationId) {
          const validationError: Yup.ValidationError[] = [];

          protocolList?.forEach((modality, index) => {
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`protocol_photo.${index}`);
              const spc = registration.data?.protocol.find((sp) => sp?.protocol_type.id === modality);
              if (spc?.photo) {
                if (file?.length === 0 && registration.data?.protocol[index]?.attachments?.length === 0) {
                  validationError.push(
                    new Yup.ValidationError(
                      'Selecione um arquivo para continuar',
                      protocolList[index],
                      `protocol_photo.${index}`,
                    ),
                  );
                }

                return true;
              } else if (file?.length === 0) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    protocolList.filter((sp) => sp !== false)[index],
                    `protocol_photo.${index}`,
                  ),
                );
                return;
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }

        if (!registrationId) {
          const validationError: Yup.ValidationError[] = [];
          protocolList?.forEach((modality, index) => {
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`protocol_photo.${index}`);
              if (file?.length === 0) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    protocolList[index],
                    `protocol_photo.${index}`,
                  ),
                );
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }
      })
      .test('TypeFile', 'Tipo de arquivo nao suportado', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`protocol_photo.${index}`);
            if (file?.length > 0) {
              const response = validateTypeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tipo de arquivo nao suportado',
                    protocolList[index],
                    `protocol_photo.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFileSize', '', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`protocol_photo.${index}`);
            if (file?.length > 0) {
              const response = validationSizeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tamanho máximo para arquivos é de 2MB',
                    protocolList[index],
                    `protocol_photo.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFile', 'Quantidade maxima de arquivos atingida (5)', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`protocol_photo.${index}`);
            if (attach && attach?.length > 0) {
              registration.data?.special_conditions.forEach((value) => {
                if (value.id === modalityListFile) {
                  const file = value?.attachments?.length || 0;
                  if (file > 4) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Quantidade maxima de arquivos atingida (5)',
                        protocolList[index],
                        `protocol_photo.${index}`,
                      ),
                    );
                  }
                }
              });
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('FileName', 'Nome de arquivo invalido', (protocolList) => {
        if (!protocolList || (protocolList && protocolList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        protocolList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`protocol_photo.${index}`);
            if (attach?.length > 0) {
              const file = validadeFileName(attach);

              if (!file) {
                validationError.push(
                  new Yup.ValidationError('Nome do arquivo invalido', protocolList[index], `protocol_photo.${index}`),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      }),
    type_exemption: Yup.string().test('required', 'Campo obrigatorio', (value) => !!value),
    subtype: Yup.string().optional(),
    // subtype: Yup.string().test('economic-subtype', 'Selecione uma situação.', (value, context) => {
    //   const type = getExemptionType(context.parent.type_exemption, getExemption.data);
    //   return !isEconomicExemption(type?.name) || Boolean(value);
    // }),
    documents: Yup.array().test(
      'economic-documents',
      'Adicione ao menos um documento com descrição.',
      (value, context) => {
        const type = getExemptionType(context.parent.type_exemption, getExemption.data);
        if (!isEconomicExemption(type?.name)) return true;
        const existing = (context.parent.existingExemptionAttachments || []).filter(
          (item: { id: string }) => !context.parent.removedExemptionAttachmentIds?.includes(item.id),
        );
        return Boolean(
          (existing.length || value?.length) && (value || []).every((item) => item?.file && item?.description?.trim()),
        );
      },
    ),
    existingExemptionAttachments: Yup.array(),
    originalExemptionTypeId: Yup.string(),
    removedExemptionAttachmentIds: Yup.array(),
    attachmentExemption: Yup.mixed<FileCollection>()
      .test('Required', 'Anexe os documentos exigidos para o tipo de isenção selecionado.', function (file, ctx) {
        const listFile = file as FileCollection;

        const typeExemptionObject = getExemptionType(ctx.parent.type_exemption, getExemption.data);

        const hasExisting = (ctx.parent.existingExemptionAttachments || []).some(
          (item: { id: string }) => !ctx.parent.removedExemptionAttachmentIds?.includes(item.id),
        );
        const message = getExemptionAttachmentError({
          exemptionName: typeExemptionObject?.name,
          fileCount: listFile?.length ?? 0,
          requiresCadunicoDocument: selectiveProcessData?.data?.request_nis_document ?? false,
          hasActiveExistingAttachment: hasExisting,
        });
        return message ? this.createError({ message }) : true;
      })
      .test('validationSizeFile', 'Tamanho máximo para arquivos é de 2MB', (file) => {
        const listFile = file as FileCollection;

        if (listFile?.length > 0) {
          return validationSizeFile(listFile);
        }

        return true;
      })
      .test('validationMaxFile', 'Quantidade máxima de arquivos é de 5 arquivos', (file) => {
        const listFile = file as FileCollection;

        if (listFile?.length > 0) {
          return validateMaxFile(listFile);
        }

        return true;
      })
      .test('validationTypeFile', 'Formato de arquivo não suportado', (file) => {
        const listFile = file as FileCollection;

        if (listFile?.length > 0) {
          return validateTypeFile(listFile);
        }

        return true;
      }),
  });

  const hasFullVacancy = savedCompetitionSelection(registration.data?.type_of_competition);

  const listChecked: (string | boolean)[] = [];
  const listObservation: (string | boolean | undefined)[] = [];

  selectiveProcessData.data?.special_condition.map((s) => {
    let isSelected = false;
    let obs = '';

    registration.data?.special_conditions.forEach((r) => {
      if (r.id === s.id) {
        isSelected = true;
        obs = r.observations;
      }
    });

    if (isSelected) {
      listChecked.push(s.id);
      listObservation.push(obs);
    } else {
      listChecked.push(false);
      listObservation.push('');
    }
  });

  const pcdDetails = registration.data?.reserved_vacancy.find((reserved) =>
    reserved.type.toLowerCase().includes('pcd'),
  );

  const hookForms = useForm({
    resolver: yupResolver(schema),
    values: {
      vacancy: registration.data?.selective_process_vacancy.id,
      type_of_competition: hasFullVacancy,
      type_of_competition_id:
        registration.data?.type_of_competition?.find((type) =>
          hasFullVacancy === ETypeOfCompetition.FULL_VACANCY
            ? /ampla/i.test(type.name)
            : hasFullVacancy === ETypeOfCompetition.UFC_SERVER_VACANCY && /ufc/i.test(type.name),
        )?.id || '',
      allow_filter_vacancy_tree: registration.data?.selective_process_vacancy?.level?.id || '',
      research_line: registration.data?.selective_process_vacancy?.research_line || '',
      thematic_axis: registration.data?.selective_process_vacancy?.thematic_axis || '',
      eligibility_declaration: registration.data?.eligibility_declaration ?? false,
      has_protocol: registration.data?.protocol?.length ? 'yes' : 'no',
      selectedProtocol:
        selectiveProcessData.data?.protocol?.map((type) =>
          registration.data?.protocol?.some((item) => item.protocol_type.id === type.id) ? type.id : false,
        ) || [],
      social_name_protocol:
        selectiveProcessData.data?.protocol?.map(
          (type) => registration.data?.protocol?.find((item) => item.protocol_type.id === type.id)?.social_name || '',
        ) || [],
      has_special_condition:
        (registration.data?.special_conditions && (registration.data.special_conditions.length > 0 ? 'yes' : 'no')) ||
        '',
      type_exemption: registration.data?.analysis_exemption?.type
        ? JSON.stringify(registration.data.analysis_exemption.type)
        : '',
      // subtype: registration.data?.analysis_exemption?.subtype?.id || '',
      documents: [],
      existingExemptionAttachments: registration.data?.analysis_exemption?.attachments || [],
      originalExemptionTypeId: registration.data?.analysis_exemption?.type?.id || '',
      removedExemptionAttachmentIds: [],
      nis: registration.data?.analysis_exemption?.nis || candidate?.nis || '',
      redome_code: registration.data?.analysis_exemption?.redome_code || '',
      is_declaration_veracity: Boolean(registrationId),
      culture_home: registration.data?.selective_process_vacancy.cultural_house,
      has_second_vacancy: registration.data?.second_vacancy ? true : false,
      culture_home_secondary: registration.data?.second_vacancy?.cultural_house,
      weapon_carry_permit: registration.data?.has_gun_license,
      initial_semester_secondary: registration.data?.second_vacancy?.id,
      juror_art_440_cpp: registration.data?.juror_art_440_cpp ? 'yes' : 'no',
      selectedSpecialCondition: listChecked,
      modality_type:
        registration.data?.type_of_competition
          ?.filter((competition) => !/ampla|ufc/i.test(competition.name))
          .map((competition) =>
            isMobile ? competition.id : JSON.stringify({ id: competition.id, name: competition.name }),
          ) || undefined,
      sub_type_of_competition: registration.data?.sub_types_of_competitions?.map((item) => item.id) ?? [],
      observation: listObservation,
      cid: pcdDetails?.cid,
      deficiency: pcdDetails?.deficiency,
      terms: registration.data?.according_to_the_terms || sessionStorage.getItem('acceptTerms') === 'true',
    },
  });

  const newRegistration = (data: FieldValues) => {
    if (isMobile) {
      const selectedType = getExemptionType(data.type_exemption, getExemption.data);

      data = {
        ...data,
        type_exemption: JSON.stringify(selectedType),
      };
    }

    if (data.type_of_competition === ETypeOfCompetition.FULL_VACANCY) {
      selectVacancy?.type_of_competition?.forEach((type) => {
        if (type?.name?.toLowerCase().includes('ampla')) {
          data = { ...data, type_of_competition: type.id, is_all: true };
        }
      });
    }

    if (selectiveProcessData.data) {
      mutateAsync({
        data,
        selectiveProcess: selectiveProcessData.data,
        listTypeCompetition: selectiveProcessVacancy.data,
        registrationId: registrationId,
        oldData: registration.data,
      })
        .then((response) => {
          if (registrationId) {
            toast({
              title: 'Sucesso',
              description: 'Isenção Editada com sucesso',
              status: 'success',
              duration: 4000,
              isClosable: true,
            });
            navigate(-1);
            return;
          }

          toast({
            title: 'Sucesso',
            description: 'Isenção criada com sucesso!',
            status: 'success',
            duration: 4000,
            isClosable: true,
          });
          navigate(
            `/processo-seletivo/${selectiveProcessId}/inscricao/${response?.id}/resumo?previous-route=/processo-seletivo/inscricao/isencao`,
          );
        })
        .catch((error) => {
          toast({
            title: 'Atenção',
            description:
              error.response?.data?.message ||
              error.response?.data?.detail ||
              error.message ||
              'Não foi possível salvar a isenção.',
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
        });
    }
  };

  const onInvalid = (errors: FieldErrors) => {
    const firstError = Object.values(errors).find((error) => error?.message);
    toast({
      title: 'Confira os dados da inscrição e isenção',
      description:
        typeof firstError?.message === 'string'
          ? firstError.message
          : 'Preencha os campos obrigatórios antes de salvar.',
      status: 'warning',
      duration: 5000,
      isClosable: true,
    });
  };

  const renderFilename = (idx: number) => {
    const files: FileList = hookForms.watch(`attachmentFile.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  if (!selectiveProcessId) navigate(-1);

  const navProps = {
    registrationId: '',
  };

  const handleShowForm = (): ReactNode => {
    const form = hookForms.watch('type_exemption');

    if (form) {
      let formToShow;
      try {
        formToShow = JSON.parse(form);
      } catch (error) {
        formToShow = getExemption.data?.find((exemption) => exemption.id === form);
      }

      if (isBoneMarrowExemption(formToShow?.name)) {
        return (
          <MarrowDonnor
            hookForms={hookForms}
            // onSetValue={hookForms.setValue}
            exemptionId={formToShow?.id}
            registrationId={navProps?.registrationId || ''}
            redomeRequired={selectiveProcessData.data?.request_redome ?? false}
          />
        );
      } else if (isCadunicoExemption(formToShow?.name)) {
        return (
          <NIS
            hookForms={hookForms}
            hideButton
            // onSetValue={hookForms.setValue}
            cpf={candidate?.cpf || ''}
            birth_date={candidate?.date_of_birth.br || ''}
            exemptionId={formToShow.id}
            exemptionName={formToShow.name}
            registrationId={navProps?.registrationId || ''}
            nisRequired={selectiveProcessData.data?.request_nis ?? false}
            documentRequired={selectiveProcessData.data?.request_nis_document ?? false}
          />
        );
      } else {
        return (
          <FormProvider {...hookForms}>
            <EconomicHyposufficiency />
          </FormProvider>
        );
      }
    }

    return false;
  };

  useEffect(() => {
    setRegistrationId(registrationId);
    setSelectiveProcessId(url);

    return () => {
      onResetRegistration();
    };
  }, []);

  const selectVacancy = useMemo(() => {
    const vacancyId = hookForms.watch('vacancy');
    if (selectiveProcessVacancy?.data) {
      return selectiveProcessVacancy?.data?.find((vac) => vacancyId === vac?.id);
    }

    return undefined;
  }, [selectiveProcessVacancy?.data, hookForms.watch('vacancy')]);

  const verifyIsPcd = (modality_type: string[], type_of_competition: string) => {
    const idsModalityType = modality_type?.map((item: string) => {
      try {
        const convertObj = JSON.parse(item);
        return convertObj.id;
      } catch (error) {
        return item;
      }
    });

    if (idsModalityType && type_of_competition) {
      const pcdId = selectVacancy?.type_of_competition?.find((item: IResponseIdName) =>
        item?.name?.toLowerCase().includes('pcd'),
      );

      return idsModalityType.includes(pcdId?.id) && type_of_competition === ETypeOfCompetition.SPECIAL_VACANCY;
    }

    return false;
  };

  const isLoading = registration.isLoading;

  const deleteAttachment = async (fileId: string) => {
    await handleDeleteAttach(fileId, toast, registration.refetch).then(() => {});
  };

  const renderFilenameProtocol = (idx: number) => {
    const files: FileList = hookForms.watch(`protocol_attachmentFile.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  const renderFilenameProtocolPhoto = (idx: number) => {
    const files: FileList = hookForms.watch(`protocol_photo.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  const deleteProtocolAttach = async (fileId: string) => {
    await handleDeleteAttach(fileId, toast, registration.refetch).then(() => {
      modal.onClose();
    });
  };

  if (isMobile)
    return (
      <FormProvider {...hookForms}>
        <CreateRegistrationMobilePage
          onSubmitForm={newRegistration}
          onInvalidForm={onInvalid}
          isLoading={selectiveProcessData.isLoading || registration.isLoading}
          sendingForm={isPending}
          registrationType={ERegistrationType.REGISTRATION_AND_EXEMPTION}
          modalityAvailable={selectVacancy?.type_of_competition}
        />
      </FormProvider>
    );

  if (spDetail.data?.general_info.exemption_registration_creation_type == 'standby') navigate(-1);

  return (
    <>
      <MainCard
        title="PROCESSO SELETIVO - "
        subtitle={registrationId ? 'MODIFICAR DADOS DA INSCRIÇÃO E ISENÇÃO' : 'FORMULÁRIO DE SOLICITAÇÃO DE ISENÇÃO'}
      >
        {(isLoading && (
          <Stack flex={1} justify="center" align="center">
            <Spinner />
          </Stack>
        )) || (
          <Flex
            as="form"
            onSubmit={hookForms.handleSubmit(newRegistration, onInvalid)}
            noValidate
            flexDir="column"
            px={['10px', '10px', '10px', '50px', '50px']}
            gap={10}
          >
            {selectiveProcessData?.data?.exemption_request_notices && (
              <MessageForUser mt={5} informationText={selectiveProcessData?.data?.exemption_request_notices || ''} />
            )}
            <Flex
              justifyContent="space-between"
              alignItems="left"
              flexDir={['column', 'column', 'column', 'row', 'row']}
              overflow="hidden"
            >
              <Stack color="darkGrey">
                <TextXS>{selectiveProcessData.data?.selective_process_type_name || ''}</TextXS>
                <TextL>{selectiveProcessData.data?.name || ''}</TextL>
              </Stack>
            </Flex>
            <Stack>
              <Accordion display="flex" flexDir="column" gap={2} allowMultiple defaultIndex={[0, 1, 2, 3, 4]}>
                <AccordionTemplate
                  title="DADOS PESSOAIS"
                  border="1px solid"
                  borderColor="primaryColor"
                  borderRadius={6}
                >
                  <Flex px={10} mb={5} flexDir={['column', 'column', 'row', 'row', 'row']}>
                    <Stack w="100%" p={3}>
                      <TextXS>
                        <strong>Nome completo:</strong> {candidate?.user?.full_name || '--'}
                      </TextXS>
                      <Stack gap={0}>
                        <TextXS>
                          <strong>{candidate?.is_foreign ? 'Passaporte' : 'CPF'}:</strong>{' '}
                          {candidate?.is_foreign ? candidate?.passport_number : candidate?.cpf || '--'} <br />
                        </TextXS>

                        <TextXXS ml="30px" as={'span'}>
                          Não é seu {candidate?.is_foreign ? 'passaporte?' : 'CPF?'}{' '}
                          <Link
                            onClick={() => {
                              signOut();
                              navigate('/');
                            }}
                            as={'span'}
                            color="colorLink"
                          >
                            clique aqui
                          </Link>
                        </TextXXS>
                      </Stack>
                      <TextXS>
                        <strong>Data de nascimento:</strong> {candidate?.date_of_birth.br || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>E-mail:</strong> {candidate?.user?.email || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>{candidate?.document_type.name || '--'}</strong>
                        {': '}
                        {candidate?.document_number || '--'} {candidate?.document_issuing_body}{' '}
                        {candidate?.document_issuing_body_uf?.initials || ''}
                      </TextXS>
                      <TextXS>
                        <strong>Sexo:</strong> {candidate?.gender?.name || '--'}
                      </TextXS>
                    </Stack>
                    <Stack w="100%" p={3}>
                      <TextXS>
                        <strong>CEP:</strong> {candidate?.address_zip_code || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Endereço:</strong> {candidate?.address_street || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Número:</strong> {candidate?.address_number || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Complemento: </strong>
                        {candidate?.address_complement || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Bairro:</strong> {candidate?.address_neighborhood || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Cidade: </strong>
                        {candidate?.address_city?.name || '--'} / {candidate?.address_state?.initials || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Telefone:</strong> {candidate?.phone || '--'}
                      </TextXS>
                      <TextXS>
                        <strong>Celular:</strong> {candidate?.cellphone || '--'}
                      </TextXS>
                    </Stack>
                  </Flex>
                  <Stack p={2}>
                    <TextXS>
                      <strong>ATENÇÃO: </strong>Os dados acima estão incorretos? caso estejam,{' '}
                      <Link
                        onClick={() => {
                          navigate('/painel/meus-dados');
                        }}
                        color="colorLink"
                      >
                        clique aqui
                      </Link>{' '}
                      e atualize seu cadastro.
                    </TextXS>
                  </Stack>
                </AccordionTemplate>
                <AccordionTemplate
                  title={selectiveProcessData.data?.is_cultural_house ? 'TURMA' : 'VAGA / CARGO DESEJADA'}
                  border="1px solid"
                  borderColor="primaryColor"
                  borderRadius={6}
                >
                  <Stack>
                    <Flex
                      display={['flex', 'flex', 'flex', 'grid', 'grid']}
                      gridTemplateColumns={['', '', '', 'repeat(1, 1fr)', 'repeat(1, 1fr)']}
                      justify="center"
                      flexDir={['column', 'column', 'column', 'row', 'row']}
                      w="100%"
                      py={3}
                      gap={3}
                    >
                      {(selectiveProcessData.data?.is_cultural_house && (
                        <VacancyCutureHome
                          selectiveProcessId={selectiveProcessId}
                          culture_houses={selectiveProcessData.data.cultural_houses}
                          isCultureHouse={selectiveProcessData.data.is_cultural_house}
                          hookForms={hookForms}
                          allow_second_registration={selectiveProcessData.data.allow_second_registration}
                        />
                      )) || (
                        <DefaultVacancyForm
                          selectiveProcessId={selectiveProcessId}
                          isFilterVacancyLevel={selectiveProcessData.data?.allow_filter_vacancy_tree}
                          isCultureHouse={selectiveProcessData.data?.is_cultural_house || false}
                          hookForms={hookForms}
                          detailPcd={pcdDetails}
                          onRemovePcdAttachment={(id) => {
                            setAttachToDeleteId(id);
                            modal.onOpen();
                          }}
                          modalityAvailable={selectVacancy?.type_of_competition}
                        />
                      )}
                    </Flex>
                  </Stack>
                </AccordionTemplate>
                {selectiveProcessData.data?.firearms_act === 'yes' && (
                  <AccordionTemplate
                    border="1px solid"
                    borderColor="primaryColor"
                    borderRadius={6}
                    title="ESTATUTO DO DESARMAMENTO"
                  >
                    <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
                      <Stack w="100%" py={3}>
                        <FormControl>
                          <Checkbox {...hookForms.register('weapon_carry_permit')}>
                            <TextXS>
                              Declaro possuir a documentação de porte de armas e tenho a necessidade de fazer a prova
                              utilizando dessa condição.
                            </TextXS>
                          </Checkbox>
                        </FormControl>
                      </Stack>
                    </Flex>
                  </AccordionTemplate>
                )}
                {selectiveProcessData.data?.allows_special_condition && (
                  <AccordionTemplate
                    border="1px solid"
                    borderColor="primaryColor"
                    borderRadius={6}
                    title="ATENDIMENTO ESPECIAL"
                  >
                    <Flex flexDir={['column', 'column', 'column', 'column', 'column']}>
                      <FormLabel fontSize="14px" fontWeight="semibold">
                        Você deseja informar algum atendimento especial para a realização da prova?
                      </FormLabel>
                      <Stack align="center" w="100%">
                        <Grid gridTemplateColumns="repeat(3, 1fr)" w="100%">
                          <FormControl textAlign="center">
                            <Select {...hookForms.register('has_special_condition')}>
                              <option value="" hidden>
                                Selecione...
                              </option>
                              <option value="yes">Sim</option>
                              <option value="no">Não</option>
                            </Select>
                            {hookForms.formState.errors.has_special_condition && (
                              <MessageError>{hookForms.formState.errors.has_special_condition?.message}</MessageError>
                            )}
                          </FormControl>
                        </Grid>

                        {hookForms.watch('has_special_condition') === 'yes' && (
                          <CheckboxGroup>
                            <Stack w="100%" gap={0} direction={['column']}>
                              {(selectiveProcessData?.data?.special_condition &&
                                selectiveProcessData?.data?.special_condition.map((condition, index) => (
                                  <Stack
                                    key={condition.id}
                                    p={hookForms.watch(`selectedSpecialCondition.${index}`) ? 4 : 1}
                                    transition="0.4s"
                                    bg={hookForms.watch(`selectedSpecialCondition.${index}`) ? 'lightGrey' : 'white'}
                                  >
                                    <label htmlFor={`${index}`}>
                                      <input
                                        id={`special-condition-${condition.id}`}
                                        style={{
                                          border: '2px solid #ff0000',
                                          width: '16px',
                                          height: '16px',
                                          marginRight: 7,
                                        }}
                                        type="checkbox"
                                        {...hookForms.register(`selectedSpecialCondition.${index}`)}
                                        value={condition.id}
                                      />
                                      {condition.name}
                                    </label>

                                    {hookForms.watch(`selectedSpecialCondition.${index}`) && (
                                      <Stack borderRadius={10}>
                                        {!condition.is_social_name && (
                                          <Textarea
                                            p={3}
                                            placeholder="Descreva em detalhes a sua necessidade."
                                            {...hookForms.register(`observation.${index}`)}
                                            bg="white"
                                            h="100px"
                                          />
                                        )}

                                        {hookForms.formState.errors.observation && (
                                          <MessageError>
                                            {hookForms.formState?.errors?.observation[index]?.message?.toString()}
                                          </MessageError>
                                        )}

                                        <Stack>
                                          <Flex align="center">
                                            <Text
                                              bg="primaryColor"
                                              color="white"
                                              w="fit-content"
                                              as="label"
                                              htmlFor={`file-${index}`}
                                              py={1.5}
                                              px={3}
                                              borderRadius={5}
                                              cursor="pointer"
                                            >
                                              Selecionar arquivo
                                            </Text>

                                            {renderFilename(index).map((filename, idx) => {
                                              return filename.length < 30 ? (
                                                <TextXS key={idx} ml={4}>
                                                  {filename}
                                                </TextXS>
                                              ) : (
                                                <Tooltip key={idx} label={filename}>
                                                  <TextXS
                                                    ml={4}
                                                  >{`${filename.substring(0, 20)}...${filename.slice(-8)}`}</TextXS>
                                                </Tooltip>
                                              );
                                            })}

                                            <Input
                                              alignContent="center"
                                              {...hookForms.register(`attachmentFile.${index}`)}
                                              type="file"
                                              id={`file-${index}`}
                                              w="fit-content"
                                              pl={0}
                                              border="none"
                                              display="none"
                                              multiple
                                            />
                                            {hookForms.formState.errors.attachmentFile && (
                                              <MessageError ml={2}>
                                                {hookForms.formState?.errors?.attachmentFile[
                                                  index
                                                ]?.message?.toString()}
                                              </MessageError>
                                            )}
                                          </Flex>
                                          {registration.data?.special_conditions
                                            .filter((sp) => condition.id === sp.id)
                                            .map((attach) => (
                                              <Stack key={attach.id}>
                                                <TableCustom headers={attachSpecialCondition}>
                                                  {(attach.attachments?.length > 0 &&
                                                    attach.attachments?.map((files) => (
                                                      <Tr key={index} textAlign="center">
                                                        <Td textAlign="center">
                                                          <Link
                                                            fontSize="14px"
                                                            color="colorLink"
                                                            target="_blank"
                                                            href={files.url}
                                                          >
                                                            {files.name}
                                                          </Link>
                                                        </Td>
                                                        <Td textAlign="center">
                                                          <TextXS>{`${files.created_at}`}</TextXS>
                                                        </Td>
                                                        <Td textAlign="center">
                                                          {condition?.has_attachment &&
                                                          attach.attachments.length > 1 ? (
                                                            <TextXS
                                                              cursor={'pointer'}
                                                              onClick={() => deleteAttachment(files.id)}
                                                              color="colorLink"
                                                            >
                                                              Excluir
                                                            </TextXS>
                                                          ) : (
                                                            !condition.has_attachment && (
                                                              <TextXS
                                                                cursor={'pointer'}
                                                                onClick={() => deleteAttachment(files.id)}
                                                                color="colorLink"
                                                              >
                                                                Excluir
                                                              </TextXS>
                                                            )
                                                          )}
                                                        </Td>
                                                      </Tr>
                                                    ))) || (
                                                    <Tr>
                                                      <Td textAlign="center" colSpan={3}>
                                                        Nenhum arquivo enviado!
                                                      </Td>
                                                    </Tr>
                                                  )}
                                                </TableCustom>
                                              </Stack>
                                            ))}
                                        </Stack>
                                      </Stack>
                                    )}
                                  </Stack>
                                ))) || <MessageError>Sem dados...</MessageError>}
                              <MessageError>
                                {hookForms.formState.errors.selectedSpecialCondition?.root?.message}
                              </MessageError>
                            </Stack>
                          </CheckboxGroup>
                        )}
                      </Stack>
                    </Flex>
                  </AccordionTemplate>
                )}

                {selectiveProcessData.data?.protocol && selectiveProcessData.data?.protocol.length > 0 && (
                  <AccordionTemplate border="1px solid" borderColor="primaryColor" borderRadius={6} title="PROTOCOLOS">
                    <Flex flexDir={['column', 'column', 'column', 'column', 'column']}>
                      <Stack align="center" w="100%">
                        <CheckboxGroup>
                          <Stack w="100%" gap={0} direction={['column']}>
                            {(selectiveProcessData?.data?.protocol &&
                              selectiveProcessData?.data?.protocol.map((protocol, index) => (
                                <Stack
                                  key={protocol.id}
                                  p={hookForms.watch(`selectedProtocol.${index}`) ? 4 : 1}
                                  transition="0.4s"
                                  bg={hookForms.watch(`selectedProtocol.${index}`) ? 'white' : 'white'}
                                >
                                  <label htmlFor={`${index}`}>
                                    <input
                                      id={`protocol-${protocol.id}`}
                                      style={{
                                        border: '2px solid #ff0000',
                                        width: '16px',
                                        height: '16px',
                                        marginRight: 7,
                                      }}
                                      type="checkbox"
                                      {...hookForms.register(`selectedProtocol.${index}`)}
                                      value={protocol.id}
                                    />
                                    {protocol.name}
                                  </label>

                                  {hookForms.watch(`selectedProtocol.${index}`) && (
                                    <Stack borderRadius={10}>
                                      {protocol.is_social_name && (
                                        <Stack>
                                          <FormControl>
                                            <FormLabel fontSize="14px" fontWeight="semibold" mb={2}>
                                              O nome social é a forma de tratamento que reflete a identidade de gênero
                                              da pessoa, especialmente importante para pessoas transgênero, travestis e
                                              não-binárias. Esta opção permite que você seja chamado(a) e
                                              identificado(a) pelo nome com o qual se reconhece, respeitando sua
                                              identidade.
                                            </FormLabel>
                                            <Input
                                              alignContent="center"
                                              placeholder="Nome social"
                                              {...hookForms.register(`social_name_protocol.${index}`)}
                                              bg="white"
                                            />
                                          </FormControl>

                                          {hookForms.formState.errors.social_name_protocol && (
                                            <MessageError>
                                              {hookForms.formState?.errors?.social_name_protocol[
                                                index
                                              ]?.message?.toString()}
                                            </MessageError>
                                          )}
                                        </Stack>
                                      )}

                                      {protocol.max_attached > 0 && (
                                        <>
                                          <Stack>
                                            <Flex align="center">
                                              <Text
                                                bg="primaryColor"
                                                color="white"
                                                w="fit-content"
                                                as="label"
                                                htmlFor={`file-attachment-${index}`}
                                                py={1.5}
                                                px={3}
                                                borderRadius={5}
                                                cursor="pointer"
                                              >
                                                Selecionar documentos
                                              </Text>

                                              {renderFilenameProtocol(index).map((filename, idx) =>
                                                filename.length < 30 ? (
                                                  <TextXS key={idx} ml={4}>
                                                    {filename}
                                                  </TextXS>
                                                ) : (
                                                  <Tooltip key={idx} label={filename}>
                                                    <TextXS ml={4}>
                                                      {`${filename.substring(0, 20)}...${filename.slice(-8)}`}
                                                    </TextXS>
                                                  </Tooltip>
                                                ),
                                              )}

                                              <Input
                                                alignContent="center"
                                                {...hookForms.register(`protocol_attachmentFile.${index}`)}
                                                type="file"
                                                id={`file-attachment-${index}`}
                                                w="fit-content"
                                                pl={0}
                                                border="none"
                                                display="none"
                                                multiple
                                              />
                                              {hookForms.formState.errors.protocol_attachmentFile && (
                                                <MessageError ml={2}>
                                                  {hookForms.formState?.errors?.protocol_attachmentFile[
                                                    index
                                                  ]?.message?.toString()}
                                                </MessageError>
                                              )}
                                            </Flex>

                                            {registration.data?.protocol
                                              .filter((sp) => protocol.id === sp.protocol_type.id)
                                              .map((attach) => (
                                                <Stack key={attach.id}>
                                                  {attach?.attachments?.map((a) => (
                                                    <Flex key={a.id} gap={2} align={'center'}>
                                                      <Link color="colorLink" target="_blank" href={a.url}>
                                                        <Tooltip label={a?.name}>
                                                          {`${a?.name.substring(0, 20)}...${a.name.slice(-8)}`}
                                                        </Tooltip>
                                                      </Link>
                                                      {attach.attachments.length > 1 && (
                                                        <Box
                                                          cursor="pointer"
                                                          onClick={() => {
                                                            setAttachToDeleteId(a?.id);
                                                            modal.onOpen();
                                                          }}
                                                        >
                                                          <IoTrash fill="red" />
                                                        </Box>
                                                      )}
                                                    </Flex>
                                                  ))}
                                                </Stack>
                                              ))}
                                          </Stack>
                                          {protocol.is_social_name && (
                                            <Stack>
                                              <Flex align="center">
                                                <Text
                                                  bg="primaryColor"
                                                  color="white"
                                                  w="fit-content"
                                                  as="label"
                                                  htmlFor={`file-photo-${index}`}
                                                  py={1.5}
                                                  px={3}
                                                  borderRadius={5}
                                                  cursor="pointer"
                                                >
                                                  Selecionar foto
                                                </Text>

                                                {renderFilenameProtocolPhoto(index).map((filename, idx) =>
                                                  filename.length < 30 ? (
                                                    <TextXS key={idx} ml={4}>
                                                      {filename}
                                                    </TextXS>
                                                  ) : (
                                                    <Tooltip key={idx} label={filename}>
                                                      <TextXS ml={4}>
                                                        {`${filename.substring(0, 20)}...${filename.slice(-8)}`}
                                                      </TextXS>
                                                    </Tooltip>
                                                  ),
                                                )}

                                                <Input
                                                  alignContent="center"
                                                  {...hookForms.register(`protocol_photo.${index}`)}
                                                  type="file"
                                                  id={`file-photo-${index}`}
                                                  w="fit-content"
                                                  pl={0}
                                                  border="none"
                                                  display="none"
                                                />
                                                {hookForms.formState.errors.protocol_photo && (
                                                  <MessageError ml={2}>
                                                    {hookForms.formState?.errors?.protocol_photo[
                                                      index
                                                    ]?.message?.toString()}
                                                  </MessageError>
                                                )}
                                              </Flex>

                                              {registration.data?.protocol
                                                .filter((sp) => protocol.id === sp.protocol_type.id)
                                                .map((attach) => (
                                                  <Stack key={attach.id}>
                                                    <Flex gap={2}>
                                                      <Link color="colorLink" target="_blank" href={attach?.photo}>
                                                        <Tooltip>{`Foto enviada`}</Tooltip>
                                                      </Link>
                                                    </Flex>
                                                  </Stack>
                                                ))}
                                            </Stack>
                                          )}
                                        </>
                                      )}
                                    </Stack>
                                  )}
                                </Stack>
                              ))) || <MessageError>Sem dados...</MessageError>}
                            <MessageError>{hookForms.formState.errors.selectedProtocol?.root?.message}</MessageError>
                          </Stack>
                        </CheckboxGroup>
                      </Stack>
                    </Flex>
                  </AccordionTemplate>
                )}

                {selectiveProcessData.data?.juror_under_article_440 === 'yes' && (
                  <AccordionTemplate border="1px solid" borderColor="primaryColor" borderRadius={6} title="JURADO">
                    <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
                      <Stack w="100%" py={3}>
                        <FormLabel fontSize="14px" fontWeight="semibold">
                          Já foi jurado nos termos do artigo 440 do código de processo penal
                        </FormLabel>
                        <Grid w="100%" gridTemplateColumns="repeat(3, 1fr)">
                          <FormControl textAlign="center">
                            <Select {...hookForms.register('juror_art_440_cpp')}>
                              <option value="" hidden>
                                Selecione...
                              </option>
                              <option value="yes">Sim</option>
                              <option value="no">Não</option>
                            </Select>
                          </FormControl>
                        </Grid>
                        <MessageError>{hookForms.formState.errors.juror_art_440_cpp?.message}</MessageError>
                      </Stack>
                    </Flex>
                  </AccordionTemplate>
                )}

                <AccordionTemplate
                  border="1px solid"
                  borderColor="primaryColor"
                  borderRadius={6}
                  title="DADOS DA SOLICITAÇÃO DE ISENÇÃO"
                >
                  <Stack>
                    <FormControl>
                      <FormLabel fontSize="14px" fontWeight="semibold">
                        Tipo de solicitação de isenção
                      </FormLabel>
                      <Select
                        {...hookForms.register('type_exemption', {
                          onChange: (event) => {
                            hookForms.clearErrors([
                              'type_exemption',
                              'subtype',
                              'documents',
                              'existingExemptionAttachments',
                              'removedExemptionAttachmentIds',
                              'attachmentExemption',
                              'nis',
                              'redome_code',
                            ]);
                            hookForms.setValue('subtype', '', { shouldDirty: true, shouldValidate: false });
                            hookForms.setValue('documents', [], { shouldDirty: true, shouldValidate: false });
                            hookForms.setValue('attachmentExemption', [], { shouldDirty: true, shouldValidate: false });
                            hookForms.setValue('nis', '', { shouldDirty: true, shouldValidate: false });
                            hookForms.setValue('redome_code', '', { shouldDirty: true, shouldValidate: false });
                            const originalType = registration.data?.analysis_exemption?.type;
                            hookForms.setValue(
                              'removedExemptionAttachmentIds',
                              originalType &&
                                getExemptionType(event.target.value, getExemption.data)?.id !== originalType.id
                                ? (registration.data?.analysis_exemption?.attachments || []).map(
                                    (attachment) => attachment.id,
                                  )
                                : [],
                              { shouldDirty: true, shouldValidate: false },
                            );
                          },
                        })}
                        w="100%"
                        maxW="350px"
                      >
                        <option hidden value="">
                          Selecione
                        </option>
                        {getExemption?.data?.map((exemption, index) => (
                          <option key={index} value={JSON.stringify(exemption)}>
                            {exemption?.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <MessageError>{hookForms.formState.errors.type_exemption?.message}</MessageError>
                    {handleShowForm()}
                    {registrationId &&
                      !isEconomicExemption(
                        getExemptionType(hookForms.watch('type_exemption'), getExemption.data)?.name,
                      ) && (
                        <FormProvider {...hookForms}>
                          <ExistingExemptionAttachments />
                        </FormProvider>
                      )}
                  </Stack>
                </AccordionTemplate>
              </Accordion>
              <Stack gap={0}>
                {!selectiveProcessData?.data?.display_terms_acceptance_before_registration && (
                  <Stack mt={5}>
                    <Checkbox isChecked={hookForms.watch('terms')} {...hookForms.register('terms')}>
                      <TextXS
                        overflow="auto"
                        dangerouslySetInnerHTML={{
                          __html:
                            selectiveProcessData?.data?.terms_of_use ||
                            'Declaro ter lido e concordado com os termos do edital.',
                        }}
                      />
                    </Checkbox>
                    <MessageError>{hookForms.formState?.errors.terms?.message}</MessageError>
                  </Stack>
                )}

                <Stack>
                  <Checkbox
                    isChecked={hookForms.watch('is_declaration_veracity')}
                    {...hookForms.register('is_declaration_veracity')}
                    alignItems="flex-start"
                    mb={0}
                  >
                    <TextXS overflow="auto">
                      Declaração de veracidade das informações, conforme a Lei nº 13.656/2018, ciente das penalidades
                      por falsidade.
                    </TextXS>
                  </Checkbox>

                  <MessageError>{hookForms.formState?.errors.is_declaration_veracity?.message}</MessageError>
                </Stack>

                {selectiveProcessData?.data?.show_eligibility_declaration && (
                  <Stack>
                    <Checkbox
                      isChecked={hookForms.watch('eligibility_declaration')}
                      {...hookForms.register('eligibility_declaration')}
                    >
                      <TextXS
                        overflow="auto"
                        dangerouslySetInnerHTML={{
                          __html: selectiveProcessData?.data?.text_eligibility_declaration || 'Declaração de titulos',
                        }}
                      />
                    </Checkbox>
                    <MessageError>{hookForms.formState?.errors.eligibility_declaration?.message}</MessageError>
                  </Stack>
                )}
              </Stack>
              <Stack flexDir="row" justify="flex-end" py={5}>
                <Button
                  w={'100px'}
                  onClick={() => {
                    navigate('/');
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  isDisabled={isPending || selectiveProcessData.isLoading}
                  type="submit"
                  bg="colorLink"
                  color="white"
                  w={'100px'}
                  _hover={'none'}
                >
                  {(isPending && <Spinner />) || (registrationId && 'Salvar') || 'Continuar'}
                </Button>
              </Stack>
            </Stack>
          </Flex>
        )}
      </MainCard>

      <Modal isOpen={modal.isOpen} onClose={modal.onClose} isCentered>
        <ModalOverlay />
        <ModalContent pb={10} maxW={['80%', '80%', '80%', '40%', '40%']} maxH="none">
          <ModalHeader textAlign="center">Excluir arquivo</ModalHeader>
          <ModalCloseButton />

          <ModalBody display="flex" flexDir="column" gap={1}>
            <Stack>
              <Stack>
                <TextXS color="red.600" fontWeight="bold">
                  Atenção: esta ação é irreversível!
                </TextXS>
                <TextXS>O arquivo enviado esta prestes a ser excluido</TextXS>
              </Stack>

              <Button onClick={() => deleteProtocolAttach(attachToDeletId)} colorScheme="red">
                Excluir arquivo
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SubscriptonAndExemption;
